import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=b344de08&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=b344de08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b344de08",
  null
  
)

/* custom blocks */
import block0 from "./Textarea.vue?vue&type=custom&index=0&blockType=i18n&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports